import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu on resize to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMobileMenuOpen]);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);

  const scrollToSection = (sectionId) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(sectionId);
    if (element) {
      const header = document.querySelector('.header');
      const headerHeight = header ? header.offsetHeight : 80;

      const elementPosition = element.offsetTop;
      const offsetPosition = elementPosition - headerHeight - 20;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''} ${isMobileMenuOpen ? 'menu-open' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <h1>Gabrielle Grace Martinez</h1>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation menu"
          aria-expanded={isMobileMenuOpen}
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>

        {/* Desktop Nav */}
        <nav className="nav desktop-nav">
          <button onClick={() => scrollToSection('work')} className="nav-link">
            Work Experience
          </button>
          <button onClick={() => scrollToSection('leadership')} className="nav-link">
            Leadership
          </button>
          <button onClick={() => scrollToSection('education')} className="nav-link">
            Education
          </button>
          <button onClick={() => scrollToSection('extracurriculars')} className="nav-link">
            Extracurriculars
          </button>
          <button onClick={() => scrollToSection('contact')} className="nav-link">
            Contact
          </button>
        </nav>

        {/* Mobile Nav Overlay */}
        <div className={`mobile-nav-overlay ${isMobileMenuOpen ? 'active' : ''}`} onClick={() => setIsMobileMenuOpen(false)}></div>

        {/* Mobile Nav */}
        <nav className={`nav mobile-nav ${isMobileMenuOpen ? 'active' : ''}`}>
          <button onClick={() => scrollToSection('work')} className="nav-link">
            <span className="nav-number">01</span>
            Work Experience
          </button>
          <button onClick={() => scrollToSection('leadership')} className="nav-link">
            <span className="nav-number">02</span>
            Leadership
          </button>
          <button onClick={() => scrollToSection('education')} className="nav-link">
            <span className="nav-number">03</span>
            Education
          </button>
          <button onClick={() => scrollToSection('extracurriculars')} className="nav-link">
            <span className="nav-number">04</span>
            Extracurriculars
          </button>
          <button onClick={() => scrollToSection('contact')} className="nav-link">
            <span className="nav-number">05</span>
            Contact
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
